// ! This file was auto-generated from the rolodex OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    authorizeApiV1OauthAuthorizeGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.oauth, id: "LIST" }]
    },
    cancelClientDeletionApiV1ClientDeletionClientIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.client_deletion, id: arg.clientId }]
    },
    createOrUpdateSamlConfigApiV1SamlConfigPilotClientIdConfigUuidPut: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.saml, id: arg.pilotClientId }, { type: Tags.saml, id: "LIST" }]
    },
    createOrUpdateSamlConfigApiV1SamlConfigPilotClientIdPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.saml, id: arg.pilotClientId }, { type: Tags.saml, id: "LIST" }]
    },
    createUserApiV1UserCreatePost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.user, id: "LIST" }]
    },
    csrfTokenApiV1TokenCsrfGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.token, id: "LIST" }]
    },
    deleteClientApiV1OauthClientsOauthClientIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.oauth_clients, id: arg.oauthClientId }]
    },
    deleteSamlConfigApiV1SamlConfigPilotClientIdConfigUuidDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.saml, id: arg.pilotClientId }, { type: Tags.saml, id: "LIST" }]
    },
    deleteUserApiV1UserDeleteUserIdDelete: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.user, id: arg.userId }, { type: Tags.user, id: "LIST" }]
    },
    evisortInitSignOutApiV1ProxySignOutPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.proxy, id: "LIST" }]
    },
    getClientApiV1OauthClientsOauthClientIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.oauth_clients, id: arg.oauthClientId }]
    },
    getClientAuthConfigsApiV1PublicAuthConfigsPilotClientSubdomainGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.public, id: arg.pilotClientSubdomain }]
    },
    getClientMappingApiV1ClientMappingGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.client_mapping, id: "LIST" }]
    },
    getClientMappingByIdApiV1ClientMappingPilotClientIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.client_mapping, id: arg.pilotClientId }]
    },
    getClientSamlConfigApiV1SamlConfigPilotClientIdConfigUuidGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.saml, id: arg.pilotClientId }]
    },
    getClientSamlConfigsApiV1SamlConfigsPilotClientIdGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.saml, id: arg.pilotClientId }]
    },
    getClientUsersApiV1UserGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.user, id: "LIST" }]
    },
    getOidcConfigApiV1OidcPilotClientSubdomainGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.oidc, id: arg.pilotClientSubdomain }]
    },
    getPreferenceApiV1UserPreferencesContextKeyGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.user_preferences, id: arg.context }]
    },
    getSelfApiV1UserSelfGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.user, id: "LIST" }]
    },
    getSmalConfigInfoApiV1SamlConfigInfoGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.saml, id: "LIST" }]
    },
    getWorkdayEnvironmentForTenantApiV1ClientMappingWorkdayEnvironmentsTenantIdTenantEnvironmentGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.client_mapping, id: arg.tenantEnvironment }]
    },
    getWorkdayEnvironmentsApiV1ClientMappingWorkdayEnvironmentsGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.client_mapping, id: "LIST" }]
    },
    handleRequestHealthLivenessGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    handleRequestHealthReadinessGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    handleRequestPingGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Healthchecks, id: "LIST" }]
    },
    idleSignOutApiV1ProxyIdleSignOutPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.proxy, id: "LIST" }]
    },
    issueTokenApiV1OauthTokenPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.oauth, id: "LIST" }]
    },
    jwksApiV1OauthWellKnownJwksJsonGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.oauth_discovery, id: "LIST" }]
    },
    listClientsApiV1OauthClientsGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.oauth_clients, id: "LIST" }]
    },
    listPreferencesApiV1UserPreferencesContextGet: {
        providesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.user_preferences, id: arg.context }]
    },
    oidcCallbackApiV1OidcCallbackGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.oidc, id: "LIST" }]
    },
    passwordAuthenticateApiV1ProxyPasswordsAuthenticatePost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.proxy, id: "LIST" }]
    },
    pusherAuthApiV1PusherAuthPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.pusher, id: "LIST" }]
    },
    queueClientDeletionApiV1ClientDeletionPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.client_deletion, id: "LIST" }]
    },
    refreshCpsFuguRegistrationApiV1ClientMappingPilotClientIdWorkdayRefreshRegistrationPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.client_mapping, id: arg.pilotClientId }]
    },
    refreshWorkdayHostsForClientApiV1ClientMappingPilotClientIdWorkdayRefreshHostsPost: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.client_mapping, id: arg.pilotClientId }]
    },
    registerClientApiV1OauthClientsPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.oauth_clients, id: "LIST" }]
    },
    restoreUserApiV1UserRestoreUserIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.user, id: arg.userId }, { type: Tags.user, id: "LIST" }]
    },
    revokeTokenApiV1OauthRevokePost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.oauth, id: "LIST" }]
    },
    sendInviteUserApiV1UserSendInviteUserIdPatch: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.user, id: arg.userId }, { type: Tags.user, id: "LIST" }]
    },
    setPasswordApiV1ProxyPasswordPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.proxy, id: "LIST" }]
    },
    setPreferenceApiV1UserPreferencesContextKeyPut: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.user_preferences, id: arg.context }]
    },
    tokenAuthenticateApiV1ProxyTokenAuthenticateGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.proxy, id: "LIST" }]
    },
    tokenRefreshApiV1TokenRefreshPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.token, id: "LIST" }]
    },
    tokenVerifyApiV1TokenVerifyPost: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.token, id: "LIST" }]
    },
    updateClientApiV1OauthClientsOauthClientIdPut: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.oauth_clients, id: arg.oauthClientId }]
    },
    updateUserApiV1UserPilotUserIdPut: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.user, id: arg.pilotUserId }, { type: Tags.user, id: "LIST" }]
    },
    updateWorkdayUserApiV1UserExternalUserIdPut: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.user, id: arg.userId }, { type: Tags.user, id: "LIST" }]
    },
    updateWorkdayUserApiV1UserWorkdayUserIdPut: {
        invalidatesTags: (_result: unknown, _error: unknown, arg: any) => [{ type: Tags.user, id: arg.userId }, { type: Tags.user, id: "LIST" }]
    },
    userinfoApiV1OauthUserinfoGet: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.oauth, id: "LIST" }]
    }
} as const;
